import React from "react";
import BaseLayout from "../layout/base/BaseLayout";
import { graphql } from "gatsby";
import Podcast from "../views/podcast/Podcast";
import Seo from "../components/Seo";
import { get } from "lodash";

const PodcastPage = ({
  data: {
    prismicPage,
    prismicForm: { data: signUpForm },
  },
  location,
}) => {
  return (
    <BaseLayout location={location} page="resources/podcast">
      <Podcast {...prismicPage} signUpFormData={signUpForm} />
    </BaseLayout>
  );
};

export default PodcastPage;

export const Head = (queryResult) => {
  const meta = get(queryResult, ["data", "prismicPage", "data", "meta"], {});

  return <Seo meta={meta} />;
};

export const pageQuery = graphql`
  {
    prismicPage(uid: { eq: "page.podcast" }, lang: { eq: "en-gb" }) {
      uid
      lang
      alternate_languages {
        lang
      }
      data {
        meta {
          document {
            __typename
            ... on PrismicMetadata {
              data {
                title
                body {
                  __typename
                  ... on PrismicMetadataDataBodyLink {
                    slice_type
                    items {
                      key
                      type
                      link {
                        url
                      }
                    }
                  }
                  ... on PrismicMetadataDataBodyText {
                    slice_type
                    items {
                      key
                      text
                      type
                    }
                  }
                }
              }
            }
          }
        }
        body {
          __typename
          ... on PrismicPageDataBodySection {
            primary {
              section_title {
                html
                text
              }
              section_text {
                html
                text
                richText
              }
              section_image {
                alt
                copyright
                url
              }
              section_cta_text {
                html
                text
              }
              section_cta_link {
                link_type
                url
                target
              }
              section_description {
                html
                text
              }
              section_header {
                html
                text
              }
              section_footer {
                html
                text
              }
            }
            items {
              item_title {
                html
                text
              }
              item_text {
                html
                text
              }
              item_image {
                alt
                copyright
                url
              }
              item_cta_text {
                html
                text
              }
              item_cta_link {
                link_type
                url
                target
              }
              item_footer {
                html
                text
              }
            }
          }
        }
      }
    }
    prismicForm(uid: { eq: "form.homepage" }) {
      data {
        checkbox {
          name
          required
          text {
            html
          }
        }
        cta_text {
          text
        }
        heading {
          html
        }
        input {
          name
          required
          text
          type
        }
        title {
          html
        }
      }
    }
  }
`;
